import type { SectorPack } from '../schema.js'

/**
 * Sector Pack "Gesundheitswesen" (M4, EDIH-Vertrag §4): generische
 * Terminologie und Regeln fuer Klinik-/Praxis-Arbeitskontexte.
 * Keine Patientendaten, keine medizinischen Faktenbehauptungen. Alle
 * Briefing-Outputs (blog_artikel, fachartikel, newsletter) tragen einen
 * Keine-Diagnose-Disclaimer und erfordern eine menschliche Freigabe.
 * Praesentationen sind im Paket nicht freigegeben (kein approvedSkill) —
 * darum gibt es dafuer auch keine Approval-/Disclaimer-Eintraege (N1).
 */
export const healthcarePack: SectorPack = {
  id: 'healthcare',
  version: '1.0.0',
  label: 'Gesundheitswesen',
  terminology: {
    'Standardarbeitsanleitung': 'Standardarbeitsanleitung (SOP)',
    'Arztbrief': 'Arztbrief',
    'Konsil': 'Konsil',
    'Medikation': 'Medikation (Arzneimittelprozess)',
    'Hygiene': 'Hygienemassnahmen',
    'Patientenpfad': 'Patientenpfad (Clinical Pathway)',
    'Fallbesprechung': 'Fallbesprechung (Board)',
    'Leitlinie': 'Medizinische Leitlinie',
    'Evidenz': 'Evidenz (Studienlage)',
    'Qualitätszirkel': 'Qualitätszirkel',
    'Aufklärung': 'Patientenaufklärung',
    'Einwilligung': 'Einwilligung (Informed Consent)',
    'Diagnostik': 'Diagnostik',
    'Therapieempfehlung': 'Therapieempfehlung',
    'Pflege': 'Pflegeprozess',
    'Notfall': 'Notfallmanagement',
    'Dokumentation': 'Medizinische Dokumentation',
    'Schnittstelle': 'Schnittstelle (Übergabe)',
    'Röntgen': 'Bildgebung (Radiologie)',
    'Labor': 'Laborresultate',
  },
  taxonomy: {
    topics: [
      'Klinische Prozesse',
      'Qualität & Sicherheit',
      'Hygiene',
      'Medikation',
      'Dokumentation',
      'Weiterbildung',
    ],
    documentTypes: [
      'SOP',
      'Leitlinien-Auszug',
      'Fallprotokoll',
      'Arztbrief',
      'Schulungsunterlage',
      'Audit-Checkliste',
    ],
  },
  sourceTypes: ['markdown', 'pdf', 'docx'],
  connectors: ['imap'],
  approvedSkills: ['research', 'memory', 'blog', 'newsletter'],
  templates: [
    { outputType: 'blog_artikel', templateRef: 'healthcare/evidence-briefing' },
    { outputType: 'fachartikel', templateRef: 'healthcare/leitlinien-review' },
    { outputType: 'newsletter', templateRef: 'healthcare/qualitaets-update' },
  ],
  providerRules: { euOnly: true, allowedProviders: ['mistral'] },
  requiredApprovals: ['blog_artikel', 'fachartikel', 'newsletter'],
  retentionDefaults: { chatDays: 90, auditDays: 3650 },
  disclaimers: [
    {
      outputType: 'blog_artikel',
      text: 'Dieses Briefing wurde maschinell erstellt und dient ausschliesslich der fachlichen Information. Es stellt keine Diagnose, keine Therapieempfehlung und keine ärztliche Beurteilung dar und ersetzt diese nicht. Klinische Entscheide sind durch qualifiziertes medizinisches Personal zu treffen.',
    },
    {
      outputType: 'fachartikel',
      text: 'Dieses Briefing wurde maschinell erstellt und dient ausschliesslich der fachlichen Information. Es stellt keine Diagnose, keine Therapieempfehlung und keine ärztliche Beurteilung dar und ersetzt diese nicht. Klinische Entscheide sind durch qualifiziertes medizinisches Personal zu treffen.',
    },
    {
      outputType: 'newsletter',
      text: 'Dieser Newsletter wurde maschinell erstellt und dient ausschliesslich der fachlichen Information. Er stellt keine Diagnose, keine Therapieempfehlung und keine ärztliche Beurteilung dar und ersetzt diese nicht. Klinische Entscheide sind durch qualifiziertes medizinisches Personal zu treffen.',
    },
  ],
  goldenFixtures: [
    {
      scenario: 'sop-literatur-set-evidence-briefing',
      fixtureRefs: ['healthcare/sop-set-beispielklinik.md'],
      expect: 'Evidence-Briefing mit Quellenverweisen, Keine-Diagnose-Disclaimer und automatischem Eintrag in der Approval-Queue.',
    },
  ],
}
